'use client';

import React, { useState } from 'react';
import { IconButton } from 'src/components/PulseUI/IconButton';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { DeleteFilterModal } from '../DeleteFilterModal';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { useEditDrawerData } from 'src/hooks/common/useEditDrawerData';
import {
  renderFilterDescription,
  renderFilterElements,
} from 'src/components/Discovery/components/PresetsDropdown/helper';
import { useSocOptions } from 'src/components/FilterSets/SiteOfCare';
import { ParentFilterGroup } from 'src/context/reducers/filterSetReducer';

interface ManageFilterProps {
  filterSet: ParentFilterGroup;
}

const ManageFilter: React.FC<ManageFilterProps> = ({ filterSet }) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const { closeAllButCurrent } = useDrawer();
  const { setCurrentFilterSetData } = useEditDrawerData();
  const { socOptions } = useSocOptions();

  const handleEdit = () => {
    // Set the current filter set data and open the edit drawer
    setCurrentFilterSetData(filterSet);
    closeAllButCurrent('entityEditFilterDrawer-discovery');
  };

  return (
    <div
      className="group px-4 pb-4 pt-3 rounded-lg transition-all duration-300 flex items-center justify-between rounded-lg outline outline-1 -outline-offset-1 outline-neutral-300"
      data-testid="manage-filter-container"
    >
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-between">
          <span data-testid="manage-filter-label">{filterSet.label}</span>
          <div className="flex items-center gap-1">
            <IconButton
              icon={faPencil}
              size="sm"
              variant="plain"
              color="neutral"
              circular
              onClick={handleEdit}
              data-testid="manage-filter-edit-button"
            />
            <IconButton
              icon={faTrash}
              size="sm"
              variant="plain"
              color="neutral"
              circular
              onClick={() => setDeleteModalOpen(true)}
              data-testid="manage-filter-delete-button"
            />
          </div>
        </div>
        <div>
          {renderFilterDescription(filterSet, renderFilterElements, socOptions)}
        </div>
      </div>
      {deleteModalOpen && (
        <DeleteFilterModal
          isOpen={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          filterSet={filterSet}
        />
      )}
    </div>
  );
};

export default ManageFilter;
